import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-ok-dialog-message',
  templateUrl: './ok-dialog.component.html',
  styleUrls: ['./ok-dialog.component.css']
})
export class OkDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }
}



// WEBPACK FOOTER //
// ./src/app/dialog/ok-dialog.component.ts